module.exports = __webpack_public_path__ + "img/category-management-icon2.707af33b.svg";